var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-supsis-partner-client-certification-status-update" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "auto.whatsappBusinessApiV2PartnerClientCertificationStatusUpdated"
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.event")))]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.clientBusinessId")))]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(
                  _vm.activity,
                  "payload.partner_client_certification_info.client_business_id"
                )
              )
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.status")))]),
          _vm._v(": "),
          _c("span", { class: _vm.statusClass }, [
            _vm._v(
              _vm._s(
                _vm.$_.get(
                  _vm.activity,
                  "payload.partner_client_certification_info.status"
                )
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.rejectionReasons.length > 0 && _vm.rejectionReasons[0] !== "NONE"
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.rejectionReasons")))]),
              _vm._v(
                ": " + _vm._s(_vm.rejectionReasons.join(", ")) + "\n        "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "raw" }, [
        _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
        _vm._v(" "),
        _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }